import { render } from "./CrearPermisos.vue?vue&type=template&id=314b9914&scoped=true"
import script from "./CrearPermisos.vue?vue&type=script&lang=js"
export * from "./CrearPermisos.vue?vue&type=script&lang=js"

import "./CrearPermisos.vue?vue&type=style&index=0&id=314b9914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314b9914"]])

export default __exports__